import { DAY_CLOSING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

export interface IClinicWalletsActionProps {
  abc: string;
}

AxiosCurlirize(axios, () => {});

export const useCMSTransactionList = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const [clinicCashList, setClinicCashList] = useState([]);

  const execute = useCallback(
    async (clinic_id: string, isSortesg: boolean) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .get(`${DAY_CLOSING_APIS?.CMS_CASH_REPORT?.baseURL}?clinic_ids=${clinic_id}&shortage_only=${isSortesg}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              setClinicCashList(res.data.data);
              return { status: true };
            } else {
              setClinicCashList([]);
              //
            }
          })
          .catch((e: AxiosError) => {
            setClinicCashList([]);
            // captureError(e);
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            return { status: false };
          });
        return response;
      } catch (e: any) {
        setClinicCashList([]);
        captureError(e);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, clinicCashList };
};
